import { render, staticRenderFns } from "./CompletedActionCard.vue?vue&type=template&id=3a90083c&scoped=true"
import script from "./CompletedActionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletedActionCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompletedActionCard.vue?vue&type=style&index=0&id=3a90083c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a90083c",
  null
  
)

export default component.exports